import {
	Pipe,
	PipeTransform,
} from '@angular/core';
import { commonUtilitiesCoreService } from '../services/core.service';

import { CommonNAFormatter } from './na_formatter.pipe';
import { CommonPrettyNumberPipe } from './pretty_number.pipe';

@Pipe({
	name: 'commonNumberWithUnitsFormatter',
})
export class CommonNumberWithUnitsFormatterPipe implements PipeTransform {
	constructor (
		private commonNAFormatter: CommonNAFormatter,
		private prettyNumber: CommonPrettyNumberPipe,
	) { }
	transform (num: any, unit?: string) {
		if (!commonUtilitiesCoreService.hasValue(num)) {
			return this.commonNAFormatter.transform(num);
		}

		return this.prettyNumber.transform(num) + (unit ? unit : '');
	}
}
